import React from 'react';
import { useTranslation } from 'next-i18next';
import { isProductAvailableForSale } from './utils/product.js';
import Button from './components/Button/index.js';
import { a as ProductType } from './product-_pRduMz7.js';
import Link from './components/Link/index.js';

const ShopButton = ({ product, link, isAdding, buttonRef, enableAddToCart, onAddSimpleProduct, onClick, }) => {
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    // SimpleProduct enabled for sale
    if (product.type_id === ProductType.Simple && enableAddToCart)
        return isProductAvailableForSale(product.backorder_status, product.stock_status) ? (React.createElement(Button, { buttonRef: buttonRef, className: "base-btn shop-now-button", type: "button", isLoading: isAdding, disabled: isAdding, onClick: onAddSimpleProduct }, tButton('addToCart'))) : (React.createElement(Button, { buttonRef: buttonRef, className: "base-btn shop-now-button", disabled: true }, tLabel('outStock')));
    // For ConfigurableProduct and SimpleProduct disabled for sale: only open a product page
    return (React.createElement(Link
    // buttonRef={buttonRef}
    , { 
        // buttonRef={buttonRef}
        href: link, className: "btn btn-main shop-now-button", onClick: onClick, noTabbing: true, noClass: true },
        React.createElement("span", null, tButton('shopNow'))));
};

export { ShopButton as S };
//# sourceMappingURL=ShopButton-3jX2bKPw.js.map
